export default __webpack_public_path__ + "static/media/button-concierge3.203e5768.png";